import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '@/services/auth';
import { useSession, startSession } from '@/stores/session';

/** Guard de rutas (Fase B). Con backend real exige sesión activa; en modo
 *  demo (sin variables de entorno) deja pasar para que previews funcionen. */
export function RequireAuth({ children }: { children: ReactNode }) {
  startSession();
  const { user, status } = useSession();

  if (!authService.isReal) return <>{children}</>;
  if (status === 'loading') {
    return (
      <div className="grid min-h-dvh place-items-center" aria-busy="true">
        <div className="skeleton h-10 w-10 rounded-2xl" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
